<template>
	<nav class="navbar bg-white navbar-expand-lg navbar-light">
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-nav" aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse text-center text-lg-left pb-4 pb-lg-0" id="main-nav">
			<a class="navbar-brand py-0 mr-0 mr-md-3" href="/">
				<Logo />
			</a>
			<div class="navbar-nav ml-auto mt-2 mt-lg-0 align-items-center">
				<router-link tag="li" :to="{ name: 'user-guide' }" class="nav-item pr-0 pr-md-3 my-3 my-md-0" active-class="active" exact>
					<a class="nav-link">User Guide</a>
				</router-link>
				<router-link tag="li" :to="{ name: 'terms-and-conditions' }" class="nav-item pr-0 pr-md-3 mb-3 mb-md-0" active-class="active" exact>
					<a class="nav-link">Terms &amp; Conditions</a>
				</router-link>
				<li class="nav-item ml-3 pr-0 pr-md-3 mb-3 mb-md-0" v-if="authenticated">
					<!-- <router-link tag="button" :to="{ name: 'user-account' }" class="btn btn-outline-primary">Your Account</router-link> -->
					<div class="dropdown">
						<button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							Your Account
						</button>
						<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
							<router-link class="dropdown-item" :to="{ name: 'report-create' }">Create Report</router-link>
							<router-link class="dropdown-item" :to="{ name: 'report-history' }">Report History</router-link>
							<router-link class="dropdown-item" :to="{ name: 'user-account' }">Edit Account</router-link>
							<router-link v-if="role === 'Admin'" class="dropdown-item" :to="{ name: 'back-office' }">Back Office</router-link>
							<a class="dropdown-item" href="#" @click="logout">Logout</a>
						</div>
					</div>
				</li>
			</div>
		</div>
	</nav>
</template>
<script>
import Logo from "@/components/icons/Logo.vue";

export default {
	name: 'MainNav',
	components: {
		Logo
	},
	data() {
    return {
      role: "User"
    };
	},
	mounted() {
		var role = localStorage.getItem('CWT_ROLE');
    if (role) {
      this.role = role;
    }
	},
	computed: {
    authenticated () {
      return this.$auth.isAuthenticated();
    }
	},
	methods: {
		logout() {
			this.$store.dispatch("logout");
		}
	}
};
</script>